export const pbThemeColors = {
    // GRAYS

    whiteAlpha75: 'rgba(255, 255, 255, 0.75)',
    whiteAlpha90: 'rgba(255, 255, 255, 0.9)',
    grayLight: 'rgba(247, 249, 251, 1)',
    grayLight2: 'rgba(220, 224, 230, 1)',
    grayLight3: 'rgba(195, 200, 206, 1)',

    gray2: 'rgba(163, 167, 176, 1)', // #a3a7b0
    gray3: 'rgba(130, 135, 145, 1)', // #828791
    grayDark: 'rgba(87, 95, 109, 1)', // #575f6d
    grayDark2: 'rgba(51, 61, 78, 1)', // #333d4e //#333d4d
    grayDark3: 'rgba(34, 41, 51, 1)',

    blackAlpha75: 'rgba(0, 0, 0, 0.75)',
    // COLORS
    blue: 'rgba(5, 189, 255, 1)',
    blueAlpha75: 'rgba(5, 189, 255, 0.75)',
    blueAlpha50: 'rgba(5, 189, 255, 0.5)',
    green: 'rgba(69, 211, 109, 1)', // #45d36d
    greenAlpha75: 'rgba(69, 211, 109, 0.75)',
    greenAlpha50: 'rgba(69, 211, 109, 0.5)',
    yellow: 'rgba(254, 215, 0, 1)', // #fed700
    yellowAlpha75: 'rgba(254, 215, 0, 0.75)',
    redAlert: 'rgba(230, 74, 73, 1)', // #e64a49
    redAlpha75: 'rgba(230, 74, 73, 0.75)',
    redDark: 'rgba(128, 41, 41, 1)', // #7f2929
    orange: 'rgba(242, 150, 28, 1)',
    orangeAlpha75: 'rgba(242, 150, 28, 0.75)',
    gold: 'rgba(198, 176, 50, 1)', // #c6b032
    mustard: 'rgba(119, 106, 11, 1)', // #776a0b
    pink: 'rgba(255, 18, 195, 1)', // #ff12c3
    pinkAlpha75: 'rgba(255, 18, 195, 0.75)',
    brown: 'rgba(164, 123, 100, 1)', // #a37b66
    brownAlpha75: 'rgba(164, 123, 100, 0.75)',
    brownDark: 'rgba(112, 76, 52, 1)', // #704c34
    brownDarkAlpha75: 'rgba(112, 76, 52, 0.75)',
    riskLevels: {
        RED: 'rgb(230, 74, 73)',
        AMBER: 'rgb(242, 150, 28)',
        YELLOW: 'rgb(254, 215, 0)',
        GREEN: 'rgb(69, 211, 109)',
    },
};

const themeColors = {
    white: 'rgba(255, 255, 255, 1)',
    black: 'rgba(0, 0, 0, 1)',
    gray: 'rgba(178, 182, 190, 1)',
    red: 'rgba(230, 74, 73, 1)', // #e64a49
    ...pbThemeColors,
};

const uses = {
    ReportsMenu: themeColors.grayDark,
    ReportsMenuSelected: themeColors.gray2,
    Tile: themeColors.grayDark2,
    alert: themeColors.red,
    warning: themeColors.yellow,
};

export const color = { ...themeColors, ...uses };
